import { data } from '../../svg/FileManager/data';
import { makeIcon } from '../makeIcon';

export const FileManager = makeIcon(data, 'file_manager', 'FileManager');

export default FileManager;
